const STORAGE_KEY = 'topPageMode';
const MODE_COOKIE_NAME = 'topPageMode';
export const TOP_PAGE_MODE = {
  LEGACY: 'legacy',
  IMPROVED: 'improved'
};

const safeLocalStorage = () => {
  try {
    return window.localStorage;
  } catch (_error) {
    return null;
  }
};

const getModeFromCookie = () => {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie.match(new RegExp(`(?:^|; )${MODE_COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const setModeCookie = (mode) => {
  if (typeof document === 'undefined') {
    return;
  }
  if (!mode) {
    document.cookie = `${MODE_COOKIE_NAME}=; path=/; max-age=0`;
    return;
  }
  const maxAge = 60 * 60 * 24 * 365; // roughly one year
  document.cookie = `${MODE_COOKIE_NAME}=${encodeURIComponent(mode)}; path=/; max-age=${maxAge}`;
};

export const getTopPageMode = () => {
  const storage = safeLocalStorage();
  const stored = storage ? storage.getItem(STORAGE_KEY) : null;
  return stored || getModeFromCookie();
};

export const setTopPageMode = (mode) => {
  const storage = safeLocalStorage();
  if (!storage) {
    setModeCookie(mode);
    return;
  }
  if (!mode) {
    storage.removeItem(STORAGE_KEY);
    setModeCookie(null);
    return;
  }
  storage.setItem(STORAGE_KEY, mode);
  setModeCookie(mode);
};

const applyModeToElement = (element, mode) => {
  if (!element) {
    return;
  }
  element.classList.toggle('top-page-improved', mode === TOP_PAGE_MODE.IMPROVED);
};

export const applyModeToBody = (mode) => {
  if (typeof document === 'undefined') {
    return;
  }
  applyModeToElement(document.body, mode);
};

const getStoredOrLegacyMode = () =>
  getTopPageMode() === TOP_PAGE_MODE.IMPROVED ? TOP_PAGE_MODE.IMPROVED : TOP_PAGE_MODE.LEGACY;

export const syncBodyWithStoredMode = () => {
  if (typeof document === 'undefined') {
    return;
  }
  applyModeToElement(document.body, getStoredOrLegacyMode());
};

export const registerTopPageModeBootstrap = () => {
  const apply = () => syncBodyWithStoredMode();
  document.addEventListener('turbolinks:load', apply);
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('turbolinks:before-render', (event) => {
    const newBody = event && event.data && event.data.newBody;
    if (!newBody) {
      return;
    }
    applyModeToElement(newBody, getStoredOrLegacyMode());
  });
  apply();
};
